import React, { useEffect, useState } from 'react'
import { useContext } from 'react';
import { useHistory, useParams } from 'react-router'
import { Col, Row, Card, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import moment from 'moment'
import Get from '../../api/Get'
import { DOCTORS_BY_SPECIALITY, GET_APPOINTMENT_BY_ID } from '../../api/Routes'
import LoadingList from "../../loader/LoadingList";
import { authContext } from "../../context/AuthContext";
import PerfilDoctorMin from '../../components/doctor/PerfilDoctorMin';
import PerfilPacienteInfo from '../../components/doctor/PerfilPacienteInfo';
import DoctorConfirmarCita from '../../components/doctor/DoctorConfirmarCita';

import '../../styles/doctores/perfilPaciente.css'
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever';
import Put from '../../api/Put';
import ModalSuccess from '../../components/ModalSuccess';

const DoctorEditarCita = ({t}) => {
    const { idCita } = useParams();
    const [doctor, setDoctor] = useState()
    const [checkedTerms, setCheckedTerms] = useState(false)
    const [loading, setLoading] = useState(false)
    const [cita, setCita] = useState(null)
    const history = useHistory();
    const [textoLoading, setTextoLoading] = useState(`${t('cargando')}...`)
    const [schedule, setSchedule] = useState(null)
    const [doctoresOptDef, setDoctoresOptDef] = useState([])
    const [especialidad, setEspecialidad] = useState(null)
    const [showSuccess, setShowSuccess] = useState(false)

    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => setShowModalServer(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)

    //cita
    //Get información de la cita
    useEffect(() => {
        setTextoLoading(`${t('cargando')}...`)
        const url = `${GET_APPOINTMENT_BY_ID}/${idCita}`
        setLoading(true)

        Get({url: url, access_token: auth.data.access_token})
        .then((resp) => {
            setCita(resp.data.data)
            setEspecialidad(resp.data.data.speciality)
            setLoading(false)
        })
        .catch((err) => {
            setShowModalServer(true)
            if(err.response){
                setErrorServer(err.response)
            }
            setLoading(false)
        })
    }, [])

    //efecto para obtener todos los doctores de esa especialidad
    useEffect(()=>{
        if(especialidad){
            Get({url: `${DOCTORS_BY_SPECIALITY}/${especialidad.id}`, access_token: auth.data.access_token})
            .then(response=>{
                let doctors = response.data.data.response.map(el=>({label: `${el.doctor.name} ${el.doctor.lastName} - ${el.doctor.providerService?.name}`, value: el.doctor.id}))
                setDoctoresOptDef(doctors)
            })
            .catch(error=>{
                setShowModalServer(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
        }
    }, [especialidad])


    const handleClickEdit = () => {
        setTextoLoading( t('actualizando_cita') )
        const dataCita = {
            schedule: schedule
        }
        setLoading(true)
        Put({url: `${GET_APPOINTMENT_BY_ID}/${cita.id}/reassigned`, data: dataCita, access_token:auth.data.access_token, header: true})
        .then( resp => {
            if(resp.data.state){
                setShowSuccess(true)
                setTimeout(() => {
                    setShowSuccess(false)
                    history.push("/admin")
                }, 3000);
            }else{
                setShowModalServer(true)
                if(resp){
                    setErrorServer(resp)
                }
            }
            //console.log(resp)
            setLoading(false)
            //history.goBack()
        })
        .catch( error => {
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }

    const onHandleChangeDoctor = value =>{
        setDoctor(value) 
        let schedule = {
            scheduleType:"Online",
            candidateDoctors : [value.value],
            hourInit: moment(cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
        }     
        setSchedule(schedule)
    } 
    const [time, setTime] = useState('')
    return (<>
        { loading && <LoadingList texto={textoLoading}/>}

        <div className='body'>
            <h1>{ t('editar_cita') }</h1>
            <br />
            <Row>
                {cita && <Col>
                    <Card className="shadow-1 formSection">
                        <PerfilPacienteInfo paciente={cita?.patientDTO} />
                    </Card>
                    <Card className="shadow-1 formSection">
                        <DoctorConfirmarCita paciente={cita?.patientDTO} setCheckedTerms={setCheckedTerms} />                    
                    </Card>
                </Col>}
                <Col>
                    {cita && 
                        <Card className="shadow-1 formSection">
                            <Card.Body>
                                <PerfilDoctorMin
                                    doctorInfo={cita?.scheduleDTO?.doctor} 
                                    scheduleDTO={cita?.scheduleDTO}
                                    speciality={cita?.speciality} 
                                    doctoresOptDef={doctoresOptDef}
                                    onHandleChangeDoctor={onHandleChangeDoctor}
                                    schedule={schedule}
                                    doctor={doctor}
                                />
                            </Card.Body>                            
                        </Card>
                    }
                    <div className="grupoBotones text-align-right">
                        <Button variant="link" 
                            className="btn-cancel-cita" 
                            type="button"
                            onClick={ ()=>history.goBack() }
                        >{t('cancelar')}</Button>{' '}
                        <Button variant="outline-success" 
                            className="ok-buttom" 
                            type="button" 
                            onClick={ handleClickEdit }
                            disabled={ (!checkedTerms || schedule===null) } 
                        >{t('confirmar')}</Button>{' '}
                    </div>
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever
            show={showModalServer}
            handleClose={handleCloseModalServer}
            error={errorServer}
        />
        <ModalSuccess show={showSuccess} setShow={setShowSuccess} />
    </>)
}

export default withTranslation()(DoctorEditarCita)